import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import ConfirmDialog from '../../components/abstractObjects/ConfirmDialog'
import { Grid, Button, Box } from '@material-ui/core'
import { BatchPackingsForm, BatchPackingsUI } from './varBatchPackingsForm'
import { selectVarById, deleteBatchPackings, toggleBatchPackingsView } from '../var/varSlice'
import { BasicLabel } from '../../components/abstractObjects/Label'
import { ToShortMonthYear } from '../../components/abstractObjects/Date'


export const VarBatchPackingsForm = ({ label, varId }) => {
    const dispatch = useDispatch()
    let deleteObj = (varId, varBatchPackingsFormId) => {
        dispatch(
            deleteBatchPackings({
                VarTransactionId: varId,
                Id: varBatchPackingsFormId
            })
        )
    }

    let varBatchPackingsFormId = useSelector((state) => state.singleVar.VarBatchPackingsFormId)
    const varx = useSelector((state) => selectVarById(state, varId))

    var varBatchPackings = varx.VarBatchPackings.find(x => x.Id === varBatchPackingsFormId)
    if (!varBatchPackings)
        varBatchPackings = {
            BatchNumber: '',
            Quantity: 0,
            ExpiryDate: ''
        }

    const [BatchNumber, setBatchNumber] = useState({ value: varBatchPackings.BatchNumber, error: null })
    const [Quantity, setQuantity] = useState({ value: varBatchPackings.Quantity, error: null })
    const [ExpiryDate, setExpiryDate] = useState({ value: varBatchPackings.ExpiryDate, error: null })

    const onBatchNumberChanged = (e) => setBatchNumber({ value: e.target.value, error: null })
    const onQuantityChanged = (e) => setQuantity({ value: e.target.value, error: null })
    const onExpiryDateChanged = (value) => setExpiryDate({ value: value, error: null })

    let cleanObj = () => {
        dispatch(toggleBatchPackingsView({ VarBatchPackingsFormId: null }))
        dispatch(toggleBatchPackingsView({ VarBatchPackingsFormId: null }))
        setBatchNumber({ value: null, error: null })
        setQuantity({ value: null, error: null })
        setExpiryDate({ value: null, error: null })
    }

    let varToggleBatchPackingsView = useSelector((state) => state.singleVar.toggleBatchPackingsView)
    const onToggleView = (e, Id = null) => {
        e.preventDefault()
        if (Id === null) {
            setBatchNumber({ value: '', error: null })
            setQuantity({ value: '', error: null })
            setExpiryDate({ value: '', error: null })
        } else {
            var batchPackings = varx.VarBatchPackings.find(x => x.Id === Id)
            setBatchNumber({ value: batchPackings.BatchNumber, error: null })
            setQuantity({ value: batchPackings.Quantity, error: null })
            setExpiryDate({ value: batchPackings.ExpiryDate, error: null })
        }
        dispatch(toggleBatchPackingsView({ VarBatchPackingsFormId: Id }))
    }
    const updateObj = () => {
        if (!varToggleBatchPackingsView) return true
        return updateBatchPackingsForm()
    }

    var [backToList, validateForm, updateBatchPackingsForm, updateBatchPackingsAndContinueForm] = BatchPackingsForm({ varId, varBatchPackingsFormId, BatchNumber, setBatchNumber, Quantity, setQuantity, ExpiryDate, setExpiryDate, cleanObj })
    var BatchPackingsData = { varId, varx, BatchNumber, onBatchNumberChanged, Quantity, onQuantityChanged, ExpiryDate, onExpiryDateChanged, varBatchPackingsFormId }
    var c = 0
    var col = varx.ImSupervisor ? 4 : 3
    const content = varx.VarBatchPackings.map((object) => {
        //if (object.varBatchPackingsFormId != varBatchPackingsFormId) return <React.Fragment key={c++} />
        return (<React.Fragment key={c++}>
            <Grid container justifyContent="space-evenly" style={{ cursor: "pointer" }}>
                <Grid item xs={12} sm={3} style={{ textAlign: "left" }} onClick={varx.ImSupervisor ? null : (e) => onToggleView(e, object.Id)}><h3>{object.BatchNumber}</h3></Grid>
                <Grid item xs={col} sm={2} onClick={varx.ImSupervisor ? null : (e) => onToggleView(e, object.Id)}><b><BasicLabel text="QUANTITY" /></b><br />{object.Quantity}</Grid>
                <Grid item xs={col} sm={3} onClick={varx.ImSupervisor ? null : (e) => onToggleView(e, object.Id)}><b><BasicLabel text="EXPIRY_DATE" /></b><br />{object.ExpiryDate != null ? ToShortMonthYear(object.ExpiryDate) : ''}</Grid>
                {varx.ImSupervisor ? <Grid item xs={2} sm={1} md={1} /> :
                    <Grid item xs={2} sm={1} md={1}>
                        <ConfirmDialog message="Do you really want to delete it?" header="Remove" agreeFunction={() => deleteObj(varx.Id, object.Id)}>
                            <Button color="primary" style={{ fontSize: "1.7rem", padding: "auto" }}>
                                <i className="fas fa-trash" style={{ fontSize: "1.75rem", fontWeight: 500 }} />
                            </Button>
                        </ConfirmDialog>
                    </Grid>}
            </Grid>
        </React.Fragment>)
    })

    let DefaultView = () => {
        var c = 0
        var i = 100
        return (
            <React.Fragment key={++c}>
                <Grid container>
                    <Grid item xs={10} style={{ marginBottom: "0.75em" }}>
                        <h5><BasicLabel text={label ?? "Batch Packings"} /></h5>
                    </Grid>
                    <Grid item xs={2} style={{ marginBottom: "0.75em" }}>
                        {varx.ImSupervisor ? '' :
                            (<Button key={++i} color="primary" onClick={(e) => onToggleView(e)} style={{ fontSize: "1.7rem", padding: "auto" }}>
                                <i className="fas fa-plus"></i>
                            </Button>)}
                    </Grid>
                </Grid>
                <Grid container>
                    {content}
                </Grid>
            </React.Fragment>
        )
    }

    let contentView
    if (varToggleBatchPackingsView) {
        contentView = <React.Fragment>
            <BatchPackingsUI VarBatchPackingsData={BatchPackingsData} saveObj={updateBatchPackingsForm} saveAndContinueObj={updateBatchPackingsAndContinueForm} backToList={backToList} validateForm={validateForm} />
            <br />
            <DefaultView />
        </React.Fragment>
    } else {
        contentView = <DefaultView />
    }
    const ui = (
        <div>{contentView}</div>
    )

    return [ui, updateObj];
}

export const VarBatchPackingsView = ({ label, varId, varBatchPackingsFormId }) => {
    const varx = useSelector((state) => selectVarById(state, varId))
    var c = 0
    var col = varx.ImSupervisor ? 4 : 3
    const content = varx.VarBatchPackings.map((object) => {
        if (object.varBatchPackingsFormId != varBatchPackingsFormId) return <React.Fragment key={c++} />
        return (<React.Fragment key={`${varBatchPackingsFormId}-${c++}`}>
            <Grid container justifyContent="space-evenly">
                <Grid item xs={12} sm={3} style={{ textAlign: "left" }}><h3>{object.BatchNumber}</h3></Grid>
                <Grid item xs={col} sm={2}><b><BasicLabel text="QUANTITY" /></b><br />{object.Quantity}</Grid>
                <Grid item xs={col} sm={3}><b><BasicLabel text="EXPIRY_DATE" /></b><br />{object.ExpiryDate != null ? ToShortMonthYear(object.ExpiryDate) : ''}</Grid>
            </Grid>
        </React.Fragment>)
    })
    return (
        <React.Fragment key={`${varBatchPackingsFormId}-${c++}`}>
            <Grid container>
                <Grid item xs={12} style={{ marginBottom: "0.75em" }}>
                    <h5><BasicLabel text={label ?? "BATCH_PACKINGS"} /></h5>
                </Grid>
            </Grid>
            <Grid container>
                {content}
            </Grid>
        </React.Fragment>
    )
}

export default VarBatchPackingsForm